module.exports = ".tangy-location-list-icon {\n    font-size: 3rem;\n  }"